// src/components/gamification/LeaderboardTable.tsx
import React from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Avatar,
    Box
} from '@mui/material';
import { LeaderboardEntry } from '../../services/interfaces';

interface LeaderboardTableProps {
    entries: LeaderboardEntry[];
}

export const LeaderboardTable: React.FC<LeaderboardTableProps> = ({ entries }) => {
    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Ранг</TableCell>
                        <TableCell>Такмичар</TableCell>
                        <TableCell align="right">Поена</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {entries.map((entry) => (
                        <TableRow
                            key={entry.userId}
                            sx={{
                                backgroundColor: entry.rank <= 3 ? `rgba(255, 215, 0, ${0.1 * (4 - entry.rank)})` : 'inherit'
                            }}
                        >
                            <TableCell>{entry.rank}</TableCell>
                            <TableCell>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Avatar src={entry.avatarUrl} alt={entry.username} />
                                    {entry.username}
                                </Box>
                            </TableCell>
                            <TableCell align="right">{entry.points}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};